import React from 'react'
import { CloudSun2 } from 'solar-icons'
import { cn } from '@/lib/utils'

interface GreetingProps extends React.ComponentPropsWithoutRef<'div'> {
  heading: string
}

export const Greeting = ({ className, heading }: GreetingProps) => {
  return (
    <div
      className={cn('flex flex-col items-center justify-end gap-4', className)}
    >
      <CloudSun2 className="size-12 md:size-16" strokeWidth={0.5} />
      <h2 className="text-2xl font-medium md:text-4xl md:font-semibold">
        {heading}
      </h2>
    </div>
  )
}
